import { Box } from '@mui/material';

import { EmergencyContact } from './components/EmergencyContact/component';
import { HomeContact } from './components/HomeContact/component';
import { OtherContact } from './components/OtherContact/component';
import { WorkContact } from './components/WorkContact/component';
import { useSxStyles } from './useStyles';

export const ContactTab = () => {
  const sxStyles = useSxStyles();

  return (
    <Box sx={sxStyles.tabContent}>
      <Box sx={sxStyles.sfSection}>
        <WorkContact />
      </Box>
      <Box sx={sxStyles.sfSection}>
        <HomeContact />
      </Box>
      <Box sx={sxStyles.sfSection}>
        <EmergencyContact />
      </Box>
      <Box sx={sxStyles.sfSection}>
        <OtherContact />
      </Box>
    </Box>
  );
};
